// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const HomeIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="HomeIcon" ref={forwardedRef} {...props}>
      <path d="m10.012 2.062 9.033 6.789-.9 1.199L17 9.19V17a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.185L1.844 10.05.945 8.849zm5.488 6-5.49-4.125L4.5 8.062V16.5h2.75v-6h5.5v6h2.75zM11.25 12h-2.5v4.25H8.749V18h2.502v-1.75H11.25z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const HomeIcon = /* @__PURE__ */ Object.assign(HomeIconComponent, {
  displayName: 'HomeIcon',
});
